<template>
  <div id="app">
    <div class="login_box_all loginbox">
      <div class="login_box_content">
        <div class="text-center login_title login_titleBox">
          《{{ $store.state.Name }}》{{ this.title }}
        </div>
        <div class="login_maxBox">
          <div class="container login_box">
            <el-tabs v-model="activeName">
              <el-tab-pane label="找回密码" name="first" class="ten">
                <el-form
                  ref="form"
                  :model="form"
                  label-width="80px"
                  class="twenfive"
                >
                  <el-form-item :label="texta + '邮箱:'">
                    <el-col :md="13" :lg="13" :xl="13" :sm="19" :xs="19">
                      <el-input
                        flag="password"
                        name="phoneAndEmail"
                        text
                        value
                        :placeholder="'请输入' + textb + '邮箱'"
                        @blur="DetectInput($event, 'phoneAndEmail')"
                        @input="DetectKey($event, 'phoneAndEmail')"
                        v-model="phoneAndEmail"
                        autocomplete="off"
                      ></el-input>
                      <div class="msg_error" v-html="phoneAndEmailTiShi"></div>
                    </el-col>
                    <el-col
                      :md="8"
                      :lg="8"
                      :xl="8"
                      :sm="8"
                      class="leftfloat ml1 myzm"
                      v-if="isshurus"
                    >
                      <el-button type="primary" plain @click="aaa()"
                        >验证该邮箱/手机号是否可用</el-button
                      >
                    </el-col>
                  </el-form-item>
                  <el-form-item label="验证码:" v-if="isShows">
                    <el-col :md="14" :lg="14" :xl="14">
                      <el-input
                        v-model="form.yzcodes"
                        placeholder="请输入图片验证码"
                        @blur="DetectInput($event, 'codes')"
                        @input="DetectKey($event, 'codes')"
                      ></el-input>
                    </el-col>
                    <el-col
                      :md="6"
                      :lg="6"
                      :xl="6"
                      :sm="6"
                      class="leftfloat ml1 myzm"
                    >
                      <span style="cursor: pointer">
                        <img
                          @click="initVeri()"
                          :src="'data:image/png;base64,' + Picturebase"
                          alt="无效"
                        />
                      </span>
                    </el-col>

                    <div class="clearfix"></div>
                    <div class="msg_error" v-html="codeTiShis"></div>
                  </el-form-item>
                  <div class="clearfix"></div>
                  <div class="twenfive" v-if="isShows">
                    <el-col
                      :md="10"
                      :lg="10"
                      :xl="10"
                      :sm="10"
                      class="leftfloat ml1 myzm"
                      v-if="iscodeBtna"
                    >
                      <el-button
                        class="five"
                        type="primary"
                        plain
                        @click="sendCodeBtn($event)"
                        v-html="Btn1"
                        style="color: #fff"
                      ></el-button>
                    </el-col>
                    <el-col
                      :md="8"
                      :lg="8"
                      :xl="8"
                      :sm="8"
                      class="leftfloat ml1 myzm"
                    >
                      <el-button
                        class="five"
                        style="width: 100%"
                        v-if="status == 0"
                        @click="$router.push('/')"
                        >取消</el-button
                      >
                    </el-col>
                  </div>
                  <el-form-item label="验证码:" v-if="!codeshow">
                    <el-col :md="15" :lg="15" :xl="15" :sm="15" :xs="13">
                      <el-input
                        autocomplete="off"
                        flag="password"
                        name="code"
                        text
                        maxlength="6"
                        placeholder="请输入手机或邮箱验证码"
                        @blur="DetectInput($event, 'code')"
                        @input="DetectKey($event, 'code')"
                        v-model="code"
                      ></el-input>
                    </el-col>

                    <div class="clearfix"></div>
                    <el-alert
                      class="five"
                      title="已发送验证码到指定邮箱，有效期为24小时"
                      type="warning"
                      v-if="codeTiShi == 0"
                    >
                    </el-alert>
                    <el-alert
                      class="five"
                      title="已发送验证码到指定手机，有效期为60秒"
                      type="warning"
                      v-if="codeTiShi == 2"
                    >
                    </el-alert>
                    <div class="msg_error" v-html="codeTiShi1"></div>
                  </el-form-item>
                  <div v-if="status == 1" style="margin-left: 81px">
                    <el-checkbox
                      v-model="checkAll"
                      @change="handleCheckAllChange"
                      >全选</el-checkbox
                    >

                    <div style="margin: 10px 0px 10px 0px">
                      <el-checkbox
                        class="rolesC"
                        v-for="(item, index) in Registered"
                        :label="item.RegisterId"
                        v-model="checkedName"
                        @change="handleCheckedCitiesChange"
                        :key="index"
                      >
                        <div>
                          用户名：{{ item.UserName }}&nbsp;&nbsp;&nbsp;&nbsp;
                          角色：{{ item.Roles }}
                        </div>
                      </el-checkbox>
                    </div>
                  </div>
                  <el-form-item label="重置密码:" v-if="status == 1">
                    <el-col>
                      <el-input
                        placeholder="请输入新密码"
                        maxlength="16"
                        type="password"
                        @blur="DetectInput($event, 'pwd')"
                        @input="DetectKey($event, 'pwd')"
                        v-model="pwd"
                        autocomplete="off"
                        show-password
                      ></el-input>
                    </el-col>
                    <div class="msg_error" v-html="pwdTiShi"></div>
                    <div class="msg_right" v-if="pwdTiShi == ''">
                      根据国家网络安全法要求，必须使用强密码（密码必须包含字母、数字、特殊字符3种形式；特殊字符仅包括.!@#_这5种西文字符；密码须8~16位）
                    </div>
                  </el-form-item>
                  <el-form-item label="确认密码:" v-if="status == 1">
                    <el-col>
                      <el-input
                        maxlength="16"
                        class="ipt_phone"
                        flag="password"
                        name="repassword"
                        type="password"
                        value
                        placeholder="请再次输入新密码"
                        @blur="DetectInput($event, 'rpwd')"
                        @input="DetectKey($event, 'rpwd')"
                        v-model="rpwd"
                        autocomplete="off"
                        show-password
                      ></el-input>
                    </el-col>
                    <div class="msg_error" v-html="rpwdTiShi"></div>
                  </el-form-item>
                  <el-form-item label v-if="status == 1">
                    <el-button style="width: 48%" type="primary" @click="forgot"
                      >提交</el-button
                    >
                    <el-button
                      style="width: 48%"
                      class="ml1"
                      @click="$router.push('/')"
                      >取消</el-button
                    >
                  </el-form-item>
                  <!-- <el-button type="primary" style=" width:100%" @click="forgot">确认</el-button> -->
                  <div class="clearfix"></div>
                  <div
                    class="leftfloat highgreen"
                    style="margin-left: 3px"
                    v-if="Ispush"
                  >
                    <i class="el-icon-success"></i> 提交成功！
                  </div>
                </el-form>
              </el-tab-pane>
            </el-tabs>
            <div class="clearfix"></div>
            <div class="login_other fifth">
              <p class="text-center">
                没有账号?<a
                  href="javascript:void(0)"
                  @click="$router.push('/regist')"
                  >立即注册</a
                >
              </p>
              <p class="text-center">
                使用其他方式登录&nbsp;&nbsp;<a href="/">返回首页</a>
              </p>
              <p class="text-center" v-if="isweixin || IsQQLogin">
                已经有<span v-if="IsQQLogin">QQ，</span>
                <span v-if="isweixin">微信</span
                >账号，可直接登录，不用重复注册。
              </p>
              <div class="clearfix"></div>
              <div class="login_other_button">
                <!-- <div class="weixin" onclick="this.className = 'weixin on';"> -->
                <el-button
                  v-if="isweixin"
                  text
                  @click="wxshow()"
                  class="weixin"
                  ><img src="../../assets/images/add_wx1.png"
                /></el-button>
                <!-- <a href="javascript:;"><img   @mouseenter="wxshow()" src="../../assets/images/add_wx1.png"></a> -->
                <el-dialog
                  v-model="dialogVisible"
                  width="30%"
                  center
                  :before-close="handleClose"
                >
                  <div v-loading="loading">
                    <p class="mobList eqcode">长按识别二维码注册并登录</p>
                    <p class="pclist eqcode">请用微信扫描二维码注册并登录</p>

                    <div>
                      <img :src="src" width="150" height="150" style="" />
                    </div>
                  </div>
                </el-dialog>
                <a
                  style="cursor: pointer"
                  @click="useqqlogin"
                  class="qq_login"
                  v-if="IsQQLogin"
                  ><img src="../../assets/images/add_qq1.png"
                /></a>
              </div>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <el-dialog
      v-model="pwdFalseShow"
      width="27%"
      class="errDia"
      :before-close="handleClose"
      title="提示"
    >
      <div style="text-align: center">
        <p>
          您的密码不符合相关要求，请<router-link
            to="/ChangePassword"
            style="color: red"
            >点击此处</router-link
          >修改密码。
        </p>
      </div>
    </el-dialog>
    <el-dialog
      title="验证码验证"
      v-model="isShow"
      custom-class="dialogwidth"
      :show-close="false"
    >
      <el-form>
        <el-form-item>
          <el-col
            :xs="6"
            :sm="6"
            :md="6"
            :lg="6"
            :xl="6"
            style="text-align: right"
            >验证码:&nbsp;&nbsp;</el-col
          >
          <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
            <el-input
              v-model="yzcodesss"
              placeholder="请输入验证码"
            ></el-input>
            <div class="msg_error" v-html="phoneTiShis"></div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" class="ml15">
            <span style="cursor: pointer">
              <div
                style="
                  height: 40px;
                  width: 110px;
                  font-size: 22px;
                  padding: 5px;
                "
              >
                <img
                  @click="initVeris()"
                  :src="'data:image/png;base64,' + Picturebases"
                  alt="无效"
                  style="height: 40px; width: 110px"
                />
              </div>
            </span>
          </el-col>
        </el-form-item>
      </el-form>

      <template v-slot:footer>
        <div class="dialog-footer" style="text-align: center">
          <el-button
            style="margin-top: 10px"
            type="primary"
            @click="bbb($event, 'name')"
            >确 定</el-button
          >
          <el-button @click="ccc">取 消</el-button>
        </div>
      </template>
    </el-dialog>
    <MasterButtom></MasterButtom>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../../utils/gogocodeTransfer'
var timeStop
import md5 from 'js-md5'
import CryptoJS from 'crypto-js'
import Login_WeiXin from '../../components/Login/Login_WeiXin'
import MasterButtom from '../../components/MasterButtom'
export default {
  name: 'login',
  data() {
    return {
      showWx: false,
      isweixin: false,
      dialogVisible: false,
      src: '',
      loading: true,
      phoneTiShis: '',
      form: {
        name: '',
        type: '',
        pass: '',
        user: '',
        yzcode: '',
        yzcodes: '',
      },
      Ispush: false,
      activeName: 'first',
      texta: '',
      textb: '',
      Btn1: '',
      iscodeBtna: true,
      status: 0,
      phoneAndEmail: '',
      code: '',
      Code: '',
      pwd: '',
      rpwd: '',
      phoneAndEmailTiShi: '            ',
      codeTiShi1: '            ',
      pwdTiShi: '            ',
      rpwdTiShi: '            ',
      wait: 60,
      codeTiShi: -1,
      backgroundDiv: {
        backgroundImage:
          'url(' + require('../../assets/images/login_bg.jpg') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      },
      user_type: '',
      title: '找回密码',
      Btn: '发送验证码',
      Picture: '',
      Picturebase: '',
      codeImg: require('../../assets/images/timg.jpg'),
      GUIDS: '',
      codeTiShis: '',
      codeshow: true,
      pwdFalseShow: false,
      Registered: [],
      checkAll: false,
      checkedName: [],
      isIndeterminate: true,
      Registereds: '',
      isShow: false,
      isShows: false,
      isshuru: false,
      isshurus: true,
      ItemCounta: '',
      yzcodesss: '',
      Picturebases: '',
      Type: '',
    }
  },
  components: {
    Login_WeiXin,
    MasterButtom,
  },
  async created() {
    this.initVeri()
  },
  async mounted() {
    if (sessionStorage.getItem('SetItem')) {
      let SetItem = JSON.parse(sessionStorage.getItem('SetItem'))
      SetItem.map((item) => {
        if (item.SetItemID == 11) {
          if (item.Item_Value == '是') {
            this.texta = '手机/'
            this.textb = '手机号或'
          } else {
            this.texta = ''
            this.textb = ''
          }
        }
        if (item.SetItemID == 2960) {
          if (item.Item_Value == '是') {
            this.isweixin = true
          } else {
            this.isweixin = false
          }
        }
      })
    } else {
      let params = [
        1000, 1001, 4530, 6018, 6019, 230, 6055, 5000, 5010, 99, 96, 11, 2960,
        310,
      ]
      this.$store.dispatch('_getSet', params).then((res) => {
        sessionStorage.setItem('SetItem', JSON.stringify(res.data.Data))
        let SetItem = res.data.Data
        SetItem.map((item) => {
          if (item.SetItemID == 11) {
            if (item.Item_Value == '是') {
              this.texta = '手机/'
              this.textb = '手机号或'
            } else {
              this.texta = ''
              this.textb = ''
            }
          }
          if (item.SetItemID == 2960) {
            if (item.Item_Value == '是') {
              this.isweixin = true
            } else {
              this.isweixin = false
            }
          }
        })
      })
    }

    this.Btn1 = '发送' + this.texta + '邮箱'
  },
  watch: {
    checkedName(newa, olda) {
      let set = new Set(newa)
      let num = Array.from(set)
      this.Registereds = num
    },
  },
  methods: {
    handleCheckAllChange(val) {
      if (this.checkAll) {
        this.Registered.forEach((item) => {
          this.checkedName.push(item.RegisterId)
        })
      } else {
        this.checkedName = []
      }
    },
    handleCheckedCitiesChange(value) {
      if (this.checkedName.length == this.Registered.length) {
        this.checkAll = true
      } else {
        this.checkAll = false
      }
    },
    async wxshow() {
      this.dialogVisible = true
      let carousel = await this.$store.dispatch('_getGetQrcode')
      if (carousel) {
        this.src = carousel.data.Url
        this.Code = carousel.data.Code
        this.loading = false
        this.handleQrcodeCheck(this.type)
        $emit(this, 'func', this.src)
      }
    },
    handleQrcodeCheck(type) {
      timeStop = window.setInterval(() => {
        this.$store
          .dispatch('_getWeiXinLogin', { Scene: this.Code })
          .then((res) => {
            if (res.data.IsSuccess) {
              if (!res.data.Data.IsGo) {
                this.pwdFalseShow = true
                return
              }
              this.$message({ message: '登录成功', type: 'success' })
              localStorage.setItem('userInfo', JSON.stringify(res.data.Data))
              var urldomain = '/'
              window.location.href = urldomain
              $emit(this, 'fuab', false)
            }
          })
      }, 2000)
    },
    async aaa() {
      if (this.phoneAndEmail) {
        //0: Email 1:用户名 2: 手机
        this.Type = -1
        if (this.$Bai(this.phoneAndEmail)) {
          this.$message({
            showClose: true,
            message: '邮箱或手机号不能为空',
            type: 'error',
          })
          return
        } else if (this.$base(this.phoneAndEmail, 'phone')) {
          this.Type = 2
        } else if (this.$base(this.phoneAndEmail, 'email')) {
          this.Type = 0
        } else {
          this.$message({
            showClose: true,
            message: '您的' + this.textb + '邮箱格式不对或者含有非法字符',
            type: 'error',
          })
          return
        }
        this.isShow = true
        this.initVeris()
      }
    },
    async bbb() {
      if (
        this.yzcodesss == '' ||
        this.yzcodesss == null ||
        this.yzcodesss == undefined
      ) {
        this.phoneTiShis = '验证码不能为空'
        return
      } else {
        if (this.yzcodesss.length < 6) {
          this.phoneTiShis = '请输入正确的验证码'
          return
        } else {
          this.phoneTiShis = ''
        }
      }
      //验证码已经发送2分钟内不能重发送
      if (this.wait != 60) {
        return
      }
      //验证email和手机是否注册过
      let res = await this.$store.dispatch('_getRegDeteCt', {
        Account: this.phoneAndEmail,
        Type: this.Type,
        Guid: this.GUIDS,
        VCode: this.yzcodesss,
      })
      if (res.data.IsSuccess == false) {
        this.phoneTiShis = res.data.Message
        this.initVeris()
      } else {
        this.isShow = false
        this.yzcodesss = ''
        this.phoneTiShis = ''
        this.ItemCounta = res.data.ItemCount
        if (res.data.ItemCount >= 1) {
          this.isShows = true
          this.isshurus = false
        } else {
          this.$message({
            showClose: true,
            message: '您的' + this.textb + '邮箱还没有注册过，无法找回密码',
            type: 'error',
          })
        }
      }
    },
    handleClose(done) {
      done()
      this.dialogVisible = false
      clearInterval(timeStop)
    },
    //鼠标离开
    DetectInput(elem, type) {
      //焦点离开时候的事件
      if (type == 'phoneAndEmail') {
        if (this.$Bai(elem.target.value)) {
          return (this.phoneAndEmailTiShi = '请输入' + this.textb + '邮箱登录')
        }
        if (this.$Space(elem.target.value)) {
          return (this.phoneAndEmailTiShi = this.textb + '邮箱不能含有空格')
        }
        if (
          !this.$base(elem.target.value, 'email') &&
          !this.$base(elem.target.value, 'phone')
        ) {
          return (this.phoneAndEmailTiShi =
            '请输入正确格式的' + this.textb + '邮箱')
        } else {
          return (this.phoneAndEmailTiShi = '')
        }
      } else if (type == 'code') {
        if (this.$Bai(elem.target.value)) {
          return (this.codeTiShi1 = '验证码不能为空')
        }
        if (this.$Space(elem.target.value)) {
          return (this.codeTiShi1 = '验证码不能含有空格')
        }
        if (elem.target.value.length < 6) {
          return (this.codeTiShi1 = '请输入六位数的验证码')
        } else {
          return (this.codeTiShi1 = '')
        }
      } else if (type == 'pwd') {
        if (this.$Bai(elem.target.value)) {
          return (this.pwdTiShi = '密码不能为空')
        } else if (elem.target.value.length < 8) {
          return (this.pwdTiShi = '密码不能小于八位字符')
        } else if (this.$Space(elem.target.value)) {
          return (this.pwdTiShi = '密码不能含有空格')
        } else if (this.$base(elem.target.value, 'aff')) {
          return (this.pwdTiShi = '密码中含有非法字符')
        } else if (!this.$base(elem.target.value, 'pass')) {
          return (this.pwdTiShi =
            '根据国家网络安全法要求，必须使用强密码（密码必须包含字母、数字、特殊字符3种形式；特殊字符仅包括.!@#_这5种西文字符；密码须8~16位）')
        } else {
          this.pwdTiShi = ''
        }
      } else if (type == 'rpwd') {
        if (this.$Bai(elem.target.value)) {
          this.rpwdTiShi = '确认密码不能为空'
        } else if (elem.target.value.length < 8) {
          this.rpwdTiShi = '确认密码不得少于八位字符'
        } else if (this.$Space(elem.target.value)) {
          return (this.rpwdTiShi = '密码不能含有空格')
        } else {
          this.rpwdTiShi = ''
        }
      }
    },
    ccc() {
      this.isShow = false
      this.yzcodesss = ''
      this.phoneTiShis = ''
    },
    //正在输入时清空错误提示
    DetectKey(elem, type) {
      let base = this.base
      if (type == 'phoneAndEmail') {
        return (this.phoneAndEmailTiShi = '')
      } else if (type == 'code') {
        return (this.codeTiShi1 = '')
      } else if (type == 'pwd') {
        return (this.pwdTiShi = '')
      } else if (type == 'rpwd') {
        return (this.rpwdTiShi = '')
      }
    },
    async sendCodeBtn(elem) {
      //点击发送验证码
      //0: Email 1:用户名 2: 手机
      let codes = this.form.yzcodes
      let Type = -1
      if (this.$Bai(this.phoneAndEmail)) {
        this.$message({
          showClose: true,
          message: '邮箱或手机号不能为空',
          type: 'error',
        })
        return
      } else if (this.$base(this.phoneAndEmail, 'phone')) {
        Type = 2
      } else if (this.$base(this.phoneAndEmail, 'email')) {
        Type = 0
      } else {
        this.$message({
          showClose: true,
          message: '您的' + this.textb + '邮箱格式不对或者含有非法字符',
          type: 'error',
        })
        return
      }
      if (codes == '' || codes == null || codes == undefined) {
        this.codeTiShis = '图片验证码不能为空'
        return
      } else {
        if (codes.length < 6) {
          this.codeTiShis = '请输入正确的图片验证码'
          return
        } else {
          this.codeTiShis = ''
        }
      }
      //验证码已经发送2分钟内不能重发送
      if (this.wait != 60) {
        return
      }
      //验证email和手机是否注册过

      if (this.ItemCounta > 0) {
        if (this.Type == 0) {
          this.user_type = 1
        } else {
          this.user_type = this.Type
        }
        this.$store
          .dispatch('_getReSetPassword', {
            MobileEmail: this.phoneAndEmail,
            CRCeMethod: this.user_type,
            VCode: this.form.yzcodes,
            VGuid: this.GUID,
          })
          .then((res) => {
            if (res.data.IsSuccess) {
              this.$message({
                message: '发送成功！',
                type: 'success',
              })
              setTimeout(() => {
                this.$router.push('/')
              }, 2000)
            }
          })
        // let res1 = await this.$store.dispatch("_getIsRegistered", {
        //   Account: this.phoneAndEmail,
        //   Type: Type,
        // });
        // console.log(res1.data.Data);
        // this.Registered = res1.data.Data;
      } else {
        this.$message({
          showClose: true,
          message: '您的' + this.textb + '邮箱还没有注册过，无法找回密码',
          type: 'error',
        })
        return
      }
    },
    timeCode() {
      //验证码时间定时器
      let time = setInterval(() => {
        if (this.wait == 0) {
          this.Btn = '重新发送验证码'
          this.wait = 60
          clearInterval(time)
        } else {
          this.Btn = '验证码(' + this.wait + ')'
          this.wait--
        }
      }, 1000)
    },
    async initVeris() {
      var random_number = Math.floor(Math.random() * (100 + 1))
      let resbase = await this.$store.dispatch('_getVerificationcodeImg')
      if (resbase.data.IsSuccess) {
        this.GUIDS = resbase.data.Data.GUID
        this.Picturebases = resbase.data.Data.Picture
      } else {
        console.log(resbase.data.Message)
      }
    },
    //页面初始化形成验证码以及GUID
    async initVeri() {
      var random_number = Math.floor(Math.random() * (100 + 1))
      let resbase = await this.$store.dispatch('_getVerificationcodeImg')
      if (resbase.data.IsSuccess) {
        this.GUID = resbase.data.Data.GUID
        this.Picturebase = resbase.data.Data.Picture
      } else {
        console.log(resbase.data.Message)
      }
    },
    randomColor() {
      var col = 'rgb('
      for (var i = 0; i < 3; i++) {
        col += Math.floor(Math.random() * 256) + ','
      }
      col = col.slice(0, -1)
      col += ')'
      return col
    },
    forgot(e) {
      //忘记密码  提交
      let status = 0
      if (this.status == 0) {
        return
      }
      if (this.$Bai(this.phoneAndEmail)) {
        status = 1
        this.phoneAndEmailTiShi = this.textb + '邮箱不能为空'
      } else if (this.$base(this.phoneAndEmail, 'aff')) {
        status = 1
        this.phoneAndEmailTiShi = '您的登录信息中含有非法字符'
      } else if (
        !this.$base(this.phoneAndEmail, 'phone') &&
        !this.$base(this.phoneAndEmail, 'email')
      ) {
        status = 1
        this.phoneAndEmailTiShi = '请输入正确格式的' + this.textb + '邮箱'
      }
      if (this.$Bai(this.code)) {
        status = 1
        this.codeTiShi1 = '验证码不能为空'
      } else if (this.code.length < 6) {
        status = 1
        this.codeTiShi1 = '请输入6位数的验证码'
      } else if (this.$base(this.code, 'aff')) {
        status = 1
        this.codeTiShi1 = '验证码中含有非法字符'
      }
      if (this.$Bai(this.pwd)) {
        status = 1
        this.pwdTiShi = '密码不能为空'
      } else if (this.pwd.length < 8) {
        status = 1
        this.pwdTiShi = '密码不能小于8位字符'
      } else if (this.$Space(this.pwd)) {
        status = 1
        this.pwdTiShi = '密码不能含有空格'
      } else if (this.$base(this.pwd, 'aff')) {
        status = 1
        this.pwdTiShi = '密码中含有非法字符'
      } else if (!this.$base(this.pwd, 'pass')) {
        status = 1
        this.pwdTiShi =
          '根据国家网络安全法要求，必须使用强密码（密码必须包含字母、数字、特殊字符3种形式；特殊字符仅包括.!@#_这5种西文字符；密码须8~16位）'
      }
      if (this.$Bai(this.rpwd)) {
        status = 1
        this.rpwdTiShi = '确认密码不能为空'
      } else if (this.rpwd.length < 8) {
        status = 1
        this.rpwdTiShi = '确认密码不能小于8位字符'
      } else if (this.$Space(this.rpwd)) {
        status = 1
        this.rpwdTiShi = '确认密码不能含有空格'
      } else if (this.$base(this.rpwd, 'aff')) {
        status = 1
        this.rpwdTiShi = '确认密码中含有非法字符'
      } else if (this.pwd != this.rpwd) {
        status = 1
        this.rpwdTiShi = '两次密码输入不一致'
      }
      if (status == 1) {
        return
      }
      let pwm = md5(this.pwd + '!@*Samson*@!')
      let pwaes = CryptoJS.AES.encrypt(this.pwd, pwm).toString()
      var data = {
        EmailMobile: this.phoneAndEmail,
        NewPassword: pwaes,
        Type: this.user_type,
        CRC: this.code,
        Npwm: pwm,
        RegisterIDs: this.Registereds,
      }
      this.$store.dispatch('_getForgetPasswordGroup', data).then((res) => {
        if (res.data.IsSuccess) {
          sessionStorage.setItem('text', 1)

          //  this.$message({
          //   showClose: true,
          //   message: "找回密码成功，跳转中·······",
          //   duration:2000,
          //   type: "success"
          // });
          // setTimeout(() => this.$router.push("/Login"), 2500);
          alert('找回密码成功~~~')
          this.$router.push('/Login')
        } else {
          return alert(res.data.Message)
        }
      })
    },
    //点击QQ登录
    // tz() {
    //   	var urldz = "https://graph.qq.com/oauth2.0/show?which=Login&display=pc&client_id=101866331&response_type=token&scope=all&redirect_uri=http%3A%2F%2F2020test.notefirst.com%2F#%2Flogin_qq";
    //   	window.location.href = urldz;
    // },
    useqqlogin() {
      var urldz =
        'https://graph.qq.com/oauth2.0/show?which=Login&display=pc&client_id=' +
        window.OpenId +
        '&response_type=token&scope=all&redirect_uri=http%3A%2F%2F' +
        window.callBackHtp +
        '%2F%23%2Flogin_qq'
      window.location.href = urldz
    },
  },
  emits: ['func', 'fuab'],
}
</script>

<style scoped>
.el-button--primary.is-plain {
  color: #fff;
}
.rolesC {
  margin-right: 50px;
  margin-bottom: 5px;
}
.el-checkbox__label {
  display: inline-block !important;
}
::v-deep .dialogwidth {
  width: 22% !important;
}
@media screen and (max-width: 1400px) and (min-width: 768px) {
  ::v-deep .dialogwidth {
    width: 40% !important;
  }
}
@media screen and (max-width: 768px) and (min-width: 440px) {
  ::v-deep .dialogwidth {
    width: 60% !important;
  }
}
@media (max-width: 440px) {
  ::v-deep .dialogwidth {
    width: 80% !important;
  }
  .myzm {
    margin-left: 0 !important;
    margin-top: 10px;
  }
}
.el-dialog__footer {
  text-align: center !important;
}
</style>
